import { render, staticRenderFns } from "./TypeEquipmentList.vue?vue&type=template&id=b2dbf488"
import script from "./TypeEquipmentList.vue?vue&type=script&lang=js"
export * from "./TypeEquipmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports